import { render } from "./IconTrekWheelSize.vue?vue&type=template&id=9cf86f78"
import script from "./IconTrekWheelSize.vue?vue&type=script&lang=js"
export * from "./IconTrekWheelSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__